module.exports = __webpack_public_path__ + "img/bulk-import.b3af75a6.png";